module.exports = __webpack_public_path__ + "static/index/img/baikal-400.f5a91e9a.jpg";